import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, Input, Button, message, Typography, Modal } from "antd";
import {
  KeyOutlined,
  EyeInvisibleOutlined,
  EyeTwoTone,
} from "@ant-design/icons";
import axios from "axios";
// import {checkLoginStatusInLocalStorage} from "./../../mylibs/list1";
// import {axiosi} from './../../../src/mylibs/list1'
// import useAxios from './../../CustomHooks/useAxios';
import useLogin from "./../../CustomHooks/useLogin";

import loginSlice from "./../../../src/redux/loginSlice";
const { Title, Paragraph, Text, Link, Link: AntLink } = Typography;
export default function Login() {
  // const {axiosi}=useAxios();
  const [visibleForgotPassword, setVisibleForgotPassword] = React.useState(false);
  const [isForgotPasswordModalVisible, setIsForgotPasswordModalVisible] =
    React.useState(false);
  const [isSubmittingForgotPassword, setIsSubmittingForgotPassword] =
    React.useState(false);
  const usernameRef = React.useRef("");
  const [form] = Form.useForm();
  const [forgotPasswordForm] = Form.useForm(); // Form cho quên mật khẩu
  const { saveLoginStatus, removeLoginStatus } = useLogin();

  const dispatch = useDispatch();

  // Xử lý khi đóng modal quên mật khẩu
  const handleCancelForgotPasswordModal = () => {
    setIsForgotPasswordModalVisible(false);
    forgotPasswordForm.resetFields(); // Reset trường trong form khi hủy
  };
  const handleDoResetPassword = async (values) => {
    try {
      // Gọi API backend để yêu cầu reset password
      // URL này là ví dụ, bạn cần thay thế bằng URL API thực tế của mình
      // console.log(values);
      // return;
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/users/doResetPassword`,
        { resetPasswordCode: values.resetPasswordCode }
      );

      console.log("[handleDoResetPassword]: response", response.data);

      // Giả sử backend trả về { success: true, message: "..." } khi thành công
      if (
        response.data.success ||
        response.status === 200 ||
        response.status === 201
      ) {
        message.success(
          response.data.message ||
            "Yêu cầu đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra email của bạn."
        );
        setIsForgotPasswordModalVisible(false);
        forgotPasswordForm.resetFields();
      } else {
        message.error(
          response.data.message || "Không thể gửi yêu cầu. Vui lòng thử lại."
        );
      }
    } catch (error) {
      console.error("[ForgotPassword]: error", error);
      if (
        error.response &&
        error.response.data &&
        error.response.data.message
      ) {
        message.error(error.response.data.message);
      } else if (error.request) {
        message.error(
          "Không thể kết nối đến máy chủ để gửi yêu cầu. Vui lòng thử lại."
        );
      } else {
        message.error("Có lỗi xảy ra khi gửi yêu cầu đặt lại mật khẩu.");
      }
    } finally {
      setIsSubmittingForgotPassword(false);
    }
    setIsForgotPasswordModalVisible(false);
  };
  const handleResetPassword = async (e) => {
    e.preventDefault();
    // setIsForgotPasswordModalVisible(true);
    // return;

    const formValues = form.getFieldsValue();
    const userlogin = { username: formValues.username };

    // if (!username) {
    //   message.error("Vui lòng nhập tên đăng nhập");
    //   return;
    // }

    try {
      message.loading({ content: "Đang xử lý...", key: "resetPassword" });
      const response = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/users/resetpassword`,
        userlogin,
        { withCredentials: true }
      );
      console.log("[ResetPassword]:done /users/resetpassword, kq=", response.data);
      const { code, message: msg } = response.data;
      switch (code) {
        case 200:
          message.success({
            content:
              "Yêu cầu đặt lại mật khẩu đã được gửi. Vui lòng kiểm tra email của bạn.",
            key: "resetPassword",
            duration: 5,
          });
          setIsForgotPasswordModalVisible(true);
          break;

        case 404:
          message.error({
            content: msg || "Không tìm thấy tài khoản",
            key: "resetPassword",
          });
          break;

        default:
          message.error({
            content: msg || "Đã xảy ra lỗi",
            key: "resetPassword",
          });
          break;
      }
    } catch (error) {
      // console.error("[ResetPassword] Error:", error);
      // console.error("error.response:", error.response.data);
      //  if (error.response) {
      //   message.error({
      //     content: error.response.data.message,
      //     key: "resetPassword",
      //   });
      //  }
      if (error.response?.data?.message) {
        message.error({
          content: error.response.data.message,
          key: "resetPassword",
        });
      } else if (error.request) {
        message.error({
          content: "request: Không thể kết nối đến máy chủ",
          key: "resetPassword",
        });
      } else {
        message.error({
          content: `Lỗi: ${error.message}`,
          key: "resetPassword",
        });
      }
    }
  };
  const onFinish = async (values) => {
    console.log("[Login]:done onFinish");
    const userlogin = { username: values.username, password: values.password };
    //const userlogin = { username: usernameRef.current.value, password: values.password };
    try {
      const kq = await axios.post(
        `${process.env.REACT_APP_DOMAIN}/users/login`,
        userlogin,
        { withCredentials: true }
      );
      console.log("[Login]:done /users/login");
      switch (kq.data.code) {
        case 200:
          break;
        case 401:
          message.error("Sai tên đăng nhập hoặc mật khẩu");
          removeLoginStatus();
          break;
        case 403:
          message.error("Tài khoản của bạn đã bị khóa");
          removeLoginStatus();
          break;
        default:
          message.error("Đăng nhập thất bại");
          removeLoginStatus();
          break;
      }
      if (kq.data.code === 200) {
        saveLoginStatus("1");
        console.log("[Login]:kq.data=", kq.data);
        dispatch(
          loginSlice.actions.setWebrtc({ webrtc: kq.data.agents[0].webrtc })
        );
        dispatch(loginSlice.actions.setUser({ user: kq.data }));
      }
      //  else {
      //   console.log("[Login]:khac 200");
      //   removeLoginStatus();
      //   message.error(kq.data.message || "Đăng nhập thất bại");
      // }
    } catch (error) {
      console.error("[Login]:error", error.message);
      console.error("[Login]:error.response.data", error.response.data);
      removeLoginStatus();

      // Hiển thị thông báo lỗi từ server nếu có
      if (error.response && error.response.data) {
        message.error(error.response.data.message || "Đăng nhập thất bại");
        const { attempts } = error.response.data;
        if (attempts >= 3) {
          setVisibleForgotPassword(true);
        } 
      } else {
        message.error("Không thể kết nối đến máy chủ");
      }
    }

    console.log("done handlelogin");
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  const i = Math.floor(Math.random() * 10) + 1;
  return (
    <div
      style={{
        backgroundImage: `url("./img/${i}.jpg")`,
        with: "100%",
        height: "100vh",
        magrin: "0vh",
        position: "fixed",
        top: "0px",
        left: "0px",
        right: "0px",
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      {/* // <div style={{"backgroundImage": `url("./img/Login.png")`,with:"100%",height:"100vh",magrin:"0vh",
        // position:"fixed",top:"0px",left:"0px",right:"0px",
        // "backgroundPosition": "center",
        // "backgroundSize": "cover"}}> */}
      <div
        style={{
          padding: "40px",
          width: "80vw",
          margin: "auto",
          // background: "#72b4c482 none repeat scroll 0% 0%",
          color: "white",
          marginTop: "15%",
          background: "rgba(114, 180, 196, 0.8)", // Điều chỉnh độ trong suốt
          boxShadow: "0 4px 15px rgba(0, 0, 0, 0.2)", // Thêm bóng đổ
        }}
      >
        <Form
          // name="basic"
          form={form}
          name="normal_login"
          className="login-form"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          // layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            // label="Username"
            name="username"
            label={<label style={{ color: "white" }}>Username</label>}
            rules={[
              {
                required: true,
                message: "Please input your username!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            // label="Password"
            name="password"
            label={<label style={{ color: "white" }}>Password</label>}
            rules={[
              {
                required: true,
                message: "Please input your password!",
              },
            ]}
          >
            <Input.Password />
          </Form.Item>

          {/* <Form.Item
        name="remember"
        valuePropName="checked"
        wrapperCol={{
          offset: 8,
          span: 16,
        }}
      >
        <Checkbox>Remember me</Checkbox>
      </Form.Item> */}
          <Form.Item
            // label=" "
            wrapperCol={{
              offset: 6,
              span: 18,
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              className="login-form-button"
            >
              Login
            </Button>
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 6,
              span: 18,
            }}
          >
            <AntLink onClick={handleResetPassword} style={{ color: "white",display:visibleForgotPassword?"block":"none" }}>
              Reset Password
            </AntLink>
          </Form.Item>
        </Form>
        {/* <div style={{ textAlign: "center" }}>
          <AntLink onClick={() => console.log("")} style={{ color: "white" }}>
            Quên mật khẩu?
          </AntLink>
        </div> */}
      </div>

      <Modal
        title="&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   Reset Password"
        visible={isForgotPasswordModalVisible}
        onCancel={handleCancelForgotPasswordModal}
        // onOk={handleDoResetPassword}
        // onCancel={() => setIsForgotPasswordModalVisible(false)}
        footer={null} // Tắt footer mặc định, sẽ dùng button trong Form
        destroyOnClose // Hủy các state của form khi modal đóng
      >
        <Paragraph style={{ marginBottom: "20px" }}>
          The "Reset Password Code" is sent to your email address. Please check
          your email and copy it to here to reset your password !
        </Paragraph>
        <Form
          form={forgotPasswordForm}
          name="forgot_password"
          // labelCol={{ span: 8 }}
          // wrapperCol={{ span: 16 }}
          initialValues={{ remember: true }}
          autoComplete="off"
          onFinish={handleDoResetPassword}
          layout="vertical"
        >
          <Form.Item
            name="resetPasswordCode"
            label={
              <label style={{ color: "black" }}>Reset Password Code:</label>
            }
            rules={[
              {
                required: true,
                message: "Please input your username!",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item style={{ textAlign: "right", marginTop: "24px" }}>
            {/* <Button onClick={handleCancelForgotPasswordModal} 
            style={{ marginRight: 8 }} 
            // disabled={isSubmittingForgotPassword}
            >
              Cancel
            </Button> */}
            <Button
              type="primary"
              htmlType="submit"
              loading={isSubmittingForgotPassword}
            >
              Reset Password
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
